// Text harvested from a winery's own website reaches a Phase-A proposal, and
// applying a proposal patches the listing verbatim — so an undecoded value
// becomes that winery's public name. The pipeline now decodes at harvest
// (lib/crawl/text.py), which is the real fix; this is the backstop for anything
// that was queued before that landed or arrives from a path we haven't covered.
//
// Two classes, both from the same source. JSON-LD is parsed as JSON, which
// resolves JSON escapes but not HTML entities, so `&amp;` survives intact. And
// a site emitting PHP addslashes() output writes `Car\\'rie`, which decodes to a
// literal backslash before the apostrophe.

// Only quotes and backslashes are unslashed. A stray backslash elsewhere is
// left alone rather than guessed at, so "AC\DC Cellars" keeps its name.
const STRAY_SLASH = /\\(['"\\])/g;

/** Decode one harvested string. Non-strings pass through untouched. */
export function decodeSiteText(value) {
  if (typeof value !== 'string') return value;
  // Decode entities exactly once, via the parser rather than a hand-rolled map,
  // so "&amp;amp;" correctly becomes "&amp;" instead of "&".
  const el = document.createElement('textarea');
  el.innerHTML = value;
  return el.value.replace(STRAY_SLASH, '$1').trim();
}

/** Decode every string in a patch object, leaving other values as they are. */
export function decodePatch(patch) {
  if (patch === null || typeof patch !== 'object') return decodeSiteText(patch);
  if (Array.isArray(patch)) return patch.map(decodePatch);
  return Object.fromEntries(
    Object.entries(patch).map(([k, v]) => [k, decodePatch(v)]),
  );
}
